module.exports = __webpack_public_path__ + "static/media/job-scraping.433d5634.png";